import { toast } from "react-toastify";
import { pinCodeApi } from "../constants/apis";
import axios from "axios";

const emptyPincodeResponse = () => ({
    district: "",
    state: "",
    village: "",
});

export const callPincodeApi = async ({ value }) => {
    const returnResponse = emptyPincodeResponse();
    try {
        const url = `${pinCodeApi}${value}`;
        const response = await axios.get(url);

        if (response.status === 200) {
            const data = response.data;
            const first = Array.isArray(data) ? data[0] : null;
            const message = first?.Message ?? "";
            const postOffice = first?.PostOffice?.[0];

            if (message.includes("found:") && postOffice) {
                return {
                    district: postOffice.District ?? "",
                    state: postOffice.State ?? "",
                    village: postOffice.Block ?? "",
                };
            }

            toast.error("Unable to get pincode data — enter district and state manually");
            return returnResponse;
        }

        toast.error("Unable to get pincode data — enter district and state manually");
        return returnResponse;
    } catch (error) {
        toast.error("Pincode lookup failed — enter district and state manually");
        return returnResponse;
    }
};

/** Auto-fill address fields only when the API returned values (keeps manual entry on failure). */
export const applyPincodeToForm = (setFieldValue, resp, { cityField = "city" } = {}) => {
    if (!resp) return;
    if (resp.district) setFieldValue("district", resp.district);
    if (resp.state) setFieldValue("state", resp.state);
    if (resp.village) setFieldValue(cityField, resp.village);
    if (resp.district || resp.state || resp.village) {
        setFieldValue("country", "India");
    }
};
